<template>
  <div class="fuel-station-popup-overlay" @click.self="$emit('close')">
    <div class="fuel-station-popup" role="dialog" aria-modal="true">
      <h3 class="fuel-station-popup__title">{{ station.name }}</h3>
      <p class="fuel-station-popup__brand">{{ brandLabel }}</p>
      <p v-if="station.address" class="fuel-station-popup__address">{{ station.address }}</p>

      <FuelPriceCards v-if="displayPrices.length" :prices="displayPrices" />
      <p v-else class="fuel-station-popup__no-fuels">нет данных</p>

      <div class="fuel-station-popup__actions">
        <template v-if="routeActions">
          <button
            v-if="!station.selected"
            type="button"
            class="btn-primary"
            @click="$emit('add')"
          >
            Добавить в маршрут
          </button>
          <button
            v-else
            type="button"
            class="btn-primary"
            @click="$emit('remove')"
          >
            Убрать из маршрута
          </button>
        </template>
        <button type="button" class="btn-secondary" @click="$emit('close')">
          Закрыть
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import FuelPriceCards from '@/components/FuelPlanner/FuelPriceCards.vue'
  import { formatStationBrand } from '@/utils/stationBrand'

  export default {
    name: 'FuelStationPopup',
    components: { FuelPriceCards },
    props: {
      station: {
        type: Object,
        required: true
      },
      /** Filtered prices from parent; falls back to station.fuels / prices */
      prices: {
        type: Array,
        default: null
      },
      /** false в browse по региону — только просмотр цен */
      routeActions: {
        type: Boolean,
        default: true
      }
    },
    emits: ['add', 'remove', 'close'],
    computed: {
      brandLabel() {
        return formatStationBrand(this.station)
      },
      displayPrices() {
        if (Array.isArray(this.prices)) return this.prices
        if (this.station?.fuels?.length) return this.station.fuels
        return Array.isArray(this.station?.prices) ? this.station.prices : []
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../../styles/variables';

  .fuel-station-popup-overlay {
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    box-sizing: border-box;
    background: rgba(26, 26, 24, 0.35);
  }

  .fuel-station-popup {
    width: 100%;
    max-width: 420px;
    padding: 20px 20px 16px;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.16);
    box-sizing: border-box;
  }

  .fuel-station-popup__title {
    margin: 0 0 4px;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.3;
    color: $black;
  }

  .fuel-station-popup__brand {
    margin: 0 0 8px;
    font-size: 13px;
    color: $grey_2;
  }

  .fuel-station-popup__address {
    margin: 0 0 12px;
    font-size: 14px;
    line-height: 1.4;
    color: $grey_1;
  }

  .fuel-station-popup__no-fuels {
    margin: 0 0 20px;
    padding: 10px 12px;
    font-size: 14px;
    color: $grey_2;
    border: 1px solid #e6eaee;
    border-radius: 8px;
  }

  :deep(.fuel-planner__fuel-cards) {
    margin: 0 0 20px;
  }

  .fuel-station-popup__actions {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .btn-primary,
    .btn-secondary {
      width: 100%;
      box-sizing: border-box;
      cursor: pointer;
    }

    .btn-secondary {
      appearance: none;
      border: 1px solid #c1c7cf;
      border-radius: 4px;
      padding: 10px 16px;
      background: #fff;
      color: $black;
      font-size: 14px;
      font-weight: 600;
    }
  }
</style>
